function ClubHistory() {
  return (
    <div style={{ width: "40%", backgroundColor: "white", alignItems:'center',marginLeft: 200}}>

      <h3>
        Lidt om klubbens unge år som skrevet i 25 års - jubilæumsfolder udgivet i
        forbindelse
        <br />
        med filatelistdagene i Ringsted den 15-17 september 1962
      </h3>
      <>
        <p style={{ textAlign: "left" }}>
          <span style={{ fontFamily: "times new roman" }}>
            <span style={{ fontSize: 16 }}>
              Ringsted og Omegns Filatelistklub er startet den 26. oktober 1937 og går
              altså i dette efterår ind i rækken af de efterhånden ikke så få 25 års
              jubilarer. Men foruden denne mærkedag kan klubben fejre endnu een,
              nemlig 25 års medlemsskab af Danmarks Filatelist Union, idet man straks
              efter starten indmeldte sig i D.F.U. — Thi, som der står i protokollen
              fra den gang: Dermed opnår man at få tilsendt unionens medlemsblad samt
              erhverver ret til at få licens til at deltage i udstillinger. Og om
              klubbens formålsparagraf skriver den lokale presse, at den er at skabe
              interesse for den »ædle sport« filatelien.
            </span>
          </span>
        </p>
        <p style={{ textAlign: "left" }}>
          <br />
          <span style={{ fontFamily: "times new roman" }}>
            <span style={{ fontSize: 16 }}>
              Klubben er startet af assurandør Martin Wismann, der også blev dens
              første formand. Wismann indkaldte til stiftende møde ovenfor nævnte dag
              på Hotel Postgaarden (hvor klubben i øvrigt har holdt til i samtlige 25
              år bortset fra en periode, hvor tyskerne havde beslaglagt hotellet), og
              denne opfordring fulgtes af 17 interesserede samlere, der alle indmeldte
              sig samme aften. Slagelseklubben, der var stiftet året forud, havde
              sendt sin bestyrelse herhen for at bistå med råd og dåd ved starten, og
              allerede ved det tredje møde, der holdtes, dukkede også Køge ind i
              billedet ved at sende sin formand hen at holde foredrag. Når vi nævner
              disse to klubber, er det for at fremhæve, at med disse to klubber, samt
              senere Holbæk og mange andre fra nær og fjern, har der til stadighed
              været et meget snævert samarbejde med gensidige besøg, enkeltvis eller i
              visse tilfælde sammen med andre klubber, når større ting var på tapetet,
              f.eks. amtsudstillingen i Slagelse for nogle år siden.
            </span>
          </span>
        </p>
        <p style={{ textAlign: "left" }}>
          <br />
          <span style={{ fontFamily: "times new roman" }}>
            <span style={{ fontSize: 16 }}>
              Allerede i 1941 mente man sig voksen nok til at afholde en udstilling,
              og på et udvalgsmøde den 13. januar samme år skulle sagen forberedes.
              Men efter at have vejet for og imod fastslog oberstløjtnant P. Lauritzen
              — der har været klubben en god læremester, streng, men retfærdig — ret
              bestemt, at der vist var for lidt at afholde udstilling på. Man var
              endnu ikke moden. Man vedtog derfor at udsætte sagen til næste år, 1942.
              Og så i stedet forberede sig lidt bedre.
              <br />
              Og det gjorde man så. Og da året var gået, var man klar til at lade
              klubbens første større arrangement løbe af stablen efter en
              tilrettelæggelse, der var forbilledlig, idet så at sige alle klubbens
              medlemmer havde været impliceret deri.
              <br />
              Dagen blev sat til den første søndag i marts (i dette tilfælde den 1.
              marts), og dette er værd at lægge mærke til, idet »Frimærkets Dag«
              arrangementer den gang altid afholdtes den første søndag i marts, og De
              vil bemærke, at klubben gennem sine 25 år har haft en stor forkærlighed
              for at lægge de forskellige arrangementer og festligheder netop på
              »Frimærkets Dag«. En dag, der i øvrigt senere er flyttet til den anden
              søndag i november.
              <br />
              Udstillingen blev en stor succes. Der var, som nu, udstillingskuvert
              (3000 stk. solgt), der var filmforevisning, der var særstempel (af
              pressen udnævnt til Danmarks smukkeste). Der blev sendt 6500
              forsendelser, der var 800 publikummer — og der var 2000,00 kroner i
              overskud. Alt sammen et resultat af — som klubbens gode ven gennem
              årene, redaktør V. C. Nielsen skrev i »Den danske Filatelist« — hvad en
              grundig forberedelse betyder for det endelige resultat.
            </span>
          </span>
        </p>
        <p style={{ textAlign: "left" }}>
          <br />
          <span style={{ fontFamily: "times new roman" }}>
            <span style={{ fontSize: 16 }}>
              Fem år senere afholdtes klubbens anden udstilling, denne gang i dagene
              8., 9. og 10. november 1947.
              <br />
              Udstillingen fik navnet »Øst for Storebælt« og var arrangeret i
              anledning af vort 10 års jubilæum. Den fik et endnu større format end
              den første og havde bl.a. international deltagelse fra Norge og Sverige.
              Den var vellykket i alle måder, og i det katalog, som udgaves, var bl.a.
              en meget interessant artikel af alle frimærkesamleres ven, nu afdøde
              blanketforvalter E. Th. Bjørn. Artiklen indeholdt alt om fremstillingen
              af Danmarks stålstukne mærker.
              <br />
              Udstillingen var åben både lørdag, søndag og mandag, og når sidstnævnte
              dag var med, skyldtes det, at der denne dag udgaves et nyt dansk
              frimærke, I. P. Jacobsen mærket.
              <br />
              Det var ved denne udstilling, at en anden af klubbens venner ved
              frokosten om søndagen generøst forærede klubben det gode og praktiske
              udstillingsmateriale, som alle Danmarks klubber nyder godt af ved at
              kunne leje til meget favorable priser.
            </span>
          </span>
        </p>
        <p style={{ textAlign: "left" }}>
          <br />
          <span style={{ fontFamily: "times new roman" }}>
            <span style={{ fontSize: 16 }}>
              Den 14. februar 1949 trak Martin Wismann sig tilbage fra formandsposten,
              og i stedet valgtes Otto Ustrup, Og det første store arrangement i hans
              regeringstid blev udstillingen på »Frimærkets Dag« den 13. november
              1949. Ved denne udstilling indviedes de nye rammer, og samtidig
              udnævntes Erik Houlberg til klubbens første æresmedlem. Selve
              udstillingen var forbeholdt klubbens medlemmer, og man havde den glæde,
              at også dette arrangement gav et overskud.
              <br />
              Allerede året efter gik man i lag med nok en udstilling og denne gang i
              forbindelse med Danmarks Filatelist Unions årsmøde, der var henlagt til
              Ringsted i dagene 2., 3. og 4. september 1950. Selve udstillingen havde
              samlet deltagelse fra så godt som samtlige klubber under D.F.U., der
              tilsluttede sig tanken om ved deltagelse at vise det arbejde, der
              præsteredes inden for D.F.U.s foreninger. At så enkelte klubber ikke
              havde opfattet ideen helt rigtigt er en sag for sig, og i hvert fald fik
              man en masse nyt materiale at se. Den arrangerende klub havde til
              gengæld ikke helt forstået de pligter, den havde som vært, idet den
              tillod sig at løbe med førstepræmien blandt de fire ærespræmier, der var
              udsat.
              <br />
              Af selve arrangementet af de festligheder, der var formet om
              udstillingen, skal vi ikke gå i detailler. Disse vil sikkert huskes af
              alle, der var med. <br />
              Længe fik klubben ikke lov at hvile på sine laurbær (undskyld!). Thi
              blot to måneder senere afholdtes fællesmøde med deltagelse af de fleste
              af Sjællands klubber. Mødet afholdtes mandag den 13. november med
              velvillig dispensation fra »Frimærkets Dag« komité, idet arrangementerne
              omkring »Frimærkets Dag« jo er anden søndag i november.
            </span>
          </span>
        </p>
        <p style={{ textAlign: "left" }}>
          <br />
          <span style={{ fontFamily: "times new roman" }}>
            <span style={{ fontSize: 16 }}>
              Også en landsjuniorudstilling har vi givet os i lag med, og denne
              afholdtes 20. april 1952 med deltagelse af ca. 50 samlinger. Vi havde
              den glæde selv at erobre udstillingens eneste uddelte gulddiplom samt et
              par sølvdiplomer. Til gengæld satte vi 250,00 kr. til på arrangementet.
              <br />
              En række fællesmøder og andre filatelistiske foreteelser udfylder tiden,
              indtil vi atter fejrer »Frimærkets Dag« og denne gang søndag den 11.
              november 1956. Fortrinsvis var det klubbens medlemmer, der udstillede.
              <br />
              Og i forbindelse med denne udstilling starter vi så vor store — stadig
              løbende konkurrence »Øst for Storebælt«, en konkurrence, der er møntet
              på at skabe lidt bedre kontakt mellem de forskellige klubber og det
              uanset »hvem« de tilhører.
              <br />
              Hvorvidt det er lykkedes, tilkommer det ikke os at give svaret på, men
              vær sikker på, at den er startet med de allerbedste hensigter, og da der
              stadig er stor interesse og stadig stor deltagelse til konkurrencen
              hvert år i november, når der kæmpes om den af os udsatte »sølvklokke«,
              ja, så har man jo lov at leve i håbet stadigvæk.
              <br />I dagene 11. og 12. april 1959 var vi medarrangør af
              amtsudstillingen i Slagelse. Det var en ganske ny idé, der her førtes ud
              i livet, en idé, som burde tages op andre steder. I dette tilfælde blev
              den en succes, og der er almindelig enighed om at gentage eksperimentet
              senere i Sorø amt.
            </span>
          </span>
        </p>
        <p style={{ textAlign: "left" }}>
          <br />
          <span style={{ fontFamily: "times new roman" }}>
            <span style={{ fontSize: 16 }}>
              Ved »Dafilu 60« 1960 i Odense deltog vi med godt resultat, idet vi
              placerede os som den bedste af de deltagende klubber, og vort største
              arrangement nu inden vort 25 års jubilæum er det fællesmøde, vi afholdt
              sidste efterår i Ringsted, selvfølgelig på »Frimærkets Dag« søndag den
              12. november.
              <br />
              Også dette møde, til hvilken der var fremskaffet aldeles dejlige
              samlinger fra d'hrr. Jacob Engel, Aage Reddersen og Robert Becksgaard,
              var tænkt som et forsøg på at nærme de forskellige parter udi filatelien
              til hinanden, og man havde den glæde, at der blev en rekorddeltagelse,
              som man ikke havde turdet drømme om, og man havde en god dag sammen. Og
              de mange takke- og sympatibreve, klubben fik i dagene derefter, er
              sikkert at opfatte som et bevis på, at det alligevel »kan nytte«.
              <br />
              Og tilbage er så at takke alle de frimærkeklubber, vi gennem disse 25 år
              er kommet i forbindelse med. Først og fremmest alle vore naboklubber for
              godt naboskab, men også alle de mange klubber mere ude i periferien. Og
              dernæst alle de mange foredragsholdere, der gennem årene har gæstet os
              og ladet os øse af deres viden. Tak til de klubber, vi har gæstet. Og
              tak til Danmarks Filatelist Union for godt samarbejde. Og til
              allersidst: Tak til alle de mange, der nu ved vort sidste arrangement,
              da vi passerer 25 år, på den ene eller anden måde har vist os venlighed,
              hjælp og støtte.
            </span>
          </span>
        </p>
        <p style={{ textAlign: "left" }}>
          <br />
          <span style={{ fontFamily: "times new roman" }}>
            <span style={{ fontSize: 16 }}>
              Vi skal på bedste måde søge at vise os værdige til al denne venlighed.
            </span>
          </span>
        </p>
        <p style={{ textAlign: "center" }}>
          <br />
        </p>
        <p style={{ textAlign: "left" }}>
          <span style={{ fontFamily: "times new roman" }}>
            <span style={{ fontSize: 16 }}>Ringsted, september 1962.</span>
          </span>
          <br />
        </p>
        <p style={{ textAlign: "right" }}>
          <span style={{ fontFamily: "times new roman" }}>
            <span style={{ fontSize: 16 }}>
              <br />
              Ringsted og Omegns Filatelistklub
            </span>
          </span>
        </p>
        <p style={{ textAlign: "right" }}>
          <span style={{ fontFamily: "times new roman" }}>
            <span style={{ fontSize: 16 }}>Otto Ustrup </span>
          </span>
        </p>
        <p style={{ textAlign: "left" }}>
          <br />
        </p>
      </>

    </div>


  );
}

export default ClubHistory;